<div class="main-container">
  <div class="stat-center">
    <div class="row-stats">
      <h1>Statistics</h1>
      <p>
        The central activity of the DOME Registry is the curation of machine
learning methods in biology from relevant publications.
Data collection, annotation and integration in The DOME Registry is
the result the efforts of expert curators and authors.

      </p>
    </div>
    <div class="row-dome">
      <div class="square">
        <h3>Users</h3>
        <p>{{ userCount$ | async }}</p>
      </div>
      <div class="square">
        <h3>Public Annotations</h3>
        <p>{{ publicAnnotationsCount$ | async }}</p>
      </div>
      <div class="square">
        <h3>Private Annotations</h3>
        <p>{{ privateAnnotationsCount$ | async }}</p>
      </div>
      <div class="square">
        <h3>Total Annotations</h3>
        <p>{{ totalAnnotationsCount$ | async }}</p>
      </div>
    </div>
  </div>
  <div class="white-divider" id="white-divider-1"></div>

  <div class="dataset">
    <h1>Dataset</h1>

    <div class="dataset-content">
      <div class="progress">
        <div class="progress-bar-container">
          <div class="progress-bar" id="vertical-scroll-progress"></div>
        </div>
        <div class="progress-titles">
          <p>1. Top 10 Annotated Journals</p>
          <p>2. Curated Papers Per Year</p>
          <p>3. Distribution of DOME Score</p>
        </div>
      </div>
      <div class="dynamic">
        <!-- Content for Top 10 Annotated Journals (default active) -->
        <div class="dynamic-content active" id="dynamic-content-0">
          <div class="journals">
            <p>Journals</p>
          </div>
          <h2>
           Top Annotated Journals in the DOME Registry
          </h2>

          <!-- Pie chart for journals -->
          <div class="journals-graph" #journalsChart></div>
        </div>

        <!-- Content for Number of Annotated Papers -->
        <div class="dynamic-content" id="dynamic-content-1">
          <div class="journals ">
            <p>Yearly</p>
          </div>
          <h2>
            Number of Annotated Papers
          </h2>
          <h3>
            Distribution of Annotated Papers by Publication Year.
                     </h3>
          <!-- Bar chart for annotated papers -->
          <div class="papers-graph" #papersChart></div>
        </div>

        <!-- Content for Distribution of Dome Score -->
        <div class="dynamic-content" id="dynamic-content-2">
          <div class="journals">
            <p>Score</p>
          </div>
          <h2>
            Distribution of DOME Score
          </h2>
          <h3>
            Analysis of the distribution of Dome scores across annotations.
          </h3>
          <!-- Bar chart for dome score -->
          <div class="scores-graph" #scoresChart></div>
        </div>
      </div>
    </div>
  </div>
  <div class="white-divider" id="white-divider-2"></div>
  <div class="score-distribution">
    <h1>Score Distribution</h1>

    <div class="score-distribution-boxes">
      <div class="box active">
        <div class="box-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="29" height="33" viewBox="0 0 29 33" fill="none">
            <path d="M8.46716 2.9292L19.4918 2.9292L24.714 8.9292V25.5959" stroke="#F66729" stroke-width="2"
                  stroke-linecap="round" stroke-linejoin="round"/>
            <path
              d="M3.8252 27.5959V8.9292C3.8252 7.82463 4.72062 6.9292 5.82519 6.9292H16.8065C17.038 6.9292 17.2581 7.02942 17.41 7.20398L21.036 11.37C21.1627 11.5157 21.2325 11.7022 21.2325 11.8953V27.5959C21.2325 28.7004 20.3371 29.5959 19.2325 29.5959H5.8252C4.72063 29.5959 3.8252 28.7004 3.8252 27.5959Z"
              stroke="#F66729" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M16.5906 6.9292V11.4625C16.5906 11.9044 16.9487 12.2625 17.3906 12.2625H21.2325" stroke="#F66729"
                  stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <h2>DATA</h2>
      </div>
      <div class="box">
        <div class="box-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="29" height="33" viewBox="0 0 29 33" fill="none">
            <path d="M8.46716 2.9292L19.4918 2.9292L24.714 8.9292V25.5959" stroke="#F66729" stroke-width="2"
                  stroke-linecap="round" stroke-linejoin="round"/>
            <path
              d="M3.8252 27.5959V8.9292C3.8252 7.82463 4.72062 6.9292 5.82519 6.9292H16.8065C17.038 6.9292 17.2581 7.02942 17.41 7.20398L21.036 11.37C21.1627 11.5157 21.2325 11.7022 21.2325 11.8953V27.5959C21.2325 28.7004 20.3371 29.5959 19.2325 29.5959H5.8252C4.72063 29.5959 3.8252 28.7004 3.8252 27.5959Z"
              stroke="#F66729" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M16.5906 6.9292V11.4625C16.5906 11.9044 16.9487 12.2625 17.3906 12.2625H21.2325" stroke="#F66729"
                  stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <h2>Optimization</h2>
      </div>
      <div class="box">
        <div class="box-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="29" height="33" viewBox="0 0 29 33" fill="none">
            <path d="M8.46716 2.9292L19.4918 2.9292L24.714 8.9292V25.5959" stroke="#F66729" stroke-width="2"
                  stroke-linecap="round" stroke-linejoin="round"/>
            <path
              d="M3.8252 27.5959V8.9292C3.8252 7.82463 4.72062 6.9292 5.82519 6.9292H16.8065C17.038 6.9292 17.2581 7.02942 17.41 7.20398L21.036 11.37C21.1627 11.5157 21.2325 11.7022 21.2325 11.8953V27.5959C21.2325 28.7004 20.3371 29.5959 19.2325 29.5959H5.8252C4.72063 29.5959 3.8252 28.7004 3.8252 27.5959Z"
              stroke="#F66729" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M16.5906 6.9292V11.4625C16.5906 11.9044 16.9487 12.2625 17.3906 12.2625H21.2325" stroke="#F66729"
                  stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <h2>Model</h2>
      </div>
      <div class="box">
        <div class="box-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="29" height="33" viewBox="0 0 29 33" fill="none">
            <path d="M8.46716 2.9292L19.4918 2.9292L24.714 8.9292V25.5959" stroke="#F66729" stroke-width="2"
                  stroke-linecap="round" stroke-linejoin="round"/>
            <path
              d="M3.8252 27.5959V8.9292C3.8252 7.82463 4.72062 6.9292 5.82519 6.9292H16.8065C17.038 6.9292 17.2581 7.02942 17.41 7.20398L21.036 11.37C21.1627 11.5157 21.2325 11.7022 21.2325 11.8953V27.5959C21.2325 28.7004 20.3371 29.5959 19.2325 29.5959H5.8252C4.72063 29.5959 3.8252 28.7004 3.8252 27.5959Z"
              stroke="#F66729" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M16.5906 6.9292V11.4625C16.5906 11.9044 16.9487 12.2625 17.3906 12.2625H21.2325" stroke="#F66729"
                  stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <h2>Evaluation</h2>
      </div>
    </div>
    <div class="score-dynamic">
      <!-- Database content (default active) -->
      <div class="score-content-block active" id="score-content-0">
        <div class="score-content">
          <div class="journals score">
            <p>Latest Updates</p>
          </div>
          <h2>
            DATA Score Distribution
          </h2>
          <h3>


Clear reporting of dataset size, composition, and class balance is essential, along with methods for handling imbalanced data. Models may also struggle with covariate shift (differences between training and related datasets) or small training sizes, for which transfer learning or specialized algorithms may help.
          </h3>
        </div>
        <div class="score-graph" #dbDistChart></div>
      </div>

      <!-- Optimization content -->
      <div class="score-content-block" id="score-content-1">
        <div class="score-content">
          <div class="journals score">
            <p>Latest Updates</p>
          </div>
          <h2>
            Optimization  score distribution
          </h2>
          <h3>
           Optimization (training) adjusts model parameters, hyperparameters, and preprocessing steps to maximize performance. Poor optimization can cause overfitting (excellent training performance but poor generalization) or underfitting (too simple models for complex data). Feature selection can help reduce overfitting but must be applied only to training data to avoid inflated performance estimates.
          </h3>
        </div>
        <div class="score-graph" #optimizationChart></div>
      </div>

      <!-- Model content -->
      <div class="score-content-block" id="score-content-2">
        <div class="score-content">
          <div class="journals score">
            <p>Latest Updates</p>
          </div>
          <h2>
            Model score distribution
          </h2>
          <h3>
            Comprehensive overview of model section, including Interpetapillity,output, Execution time, and Software availability.
            This analysis helps identify strengths and weaknesses of the annotation in the model section modeling approaches.
          </h3>
        </div>
        <div class="score-graph" #modelChart></div>
      </div>

      <!-- Evaluation content -->
      <div class="score-content-block" id="score-content-3">
        <div class="score-content">
          <div class="journals score">
            <p>Latest Updates</p>
          </div>
          <h2>
            Evaluation Results
          </h2>
          <h3>
            Summary of evaluation results across different datasets and test scenarios. These results provide insights
            into the overall performance and reliability of the system under various conditions.
          </h3>
        </div>
        <div class="score-graph" #evaluationChart></div>
      </div>
    </div>
  </div>
  <div class="white-divider" id="white-divider-2"></div>
  <div class="partner-section">
    <h1>Partner Resource</h1>
    <div class="partner-content">
      <div class="partner-description">
        <h2>
          APICURON
        </h2>
        <h3>
          APICURON collects and aggregates activity events from third party resources and
          generates statistics, achievements and leaderboards! <br>
          APICURON is endorsed by the International Society for Biocuration (ISB) as a service dedicated to crediting
          and recognizing the invaluable work of professional and volunteer biocurators.
        </h3>
        <a class="custom-button gradient-button"  href="https://apicuron.org/">visit Website
          <i>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                 stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M5 12h14"></path>
              <path d="M12 5l7 7-7 7"></path>
            </svg>
          </i>
        </a>
      </div>
      <div class="partner-image">
        <img src="assets/Frame%2087.png" alt="apicuron">
      </div>
    </div>
  </div>
  <div class=" my-4 mx-2  "  id="leaderboard">
    <div class="card">
      <div class="card-body text-center">
        <img src="https://apicuron.org/assets/APICURON.svg" alt="apicuron logo" class="img-fluid mb-3" style="max-width: 200px;">
        <div class="card-title text-black mb-3"><h2>Top Contributors</h2></div>

        <apicuron-leaderboard resource="dome_id" [options]="['total-leaderboard']"></apicuron-leaderboard>

      </div>


    </div>
  </div>
  <app-submit></app-submit>
  <app-big-footer></app-big-footer>
</div>
